const API = 'https://api.polygonscan.com/api';

export async function fetchPolygonscan(address) {
    const key = process.env.REACT_APP_POLYGONSCAN_API_KEY;
    const url = `${API}?module=account&action=txlist&address=${address}&startblock=0&endblock=99999999&page=1&offset=10000&apikey=${key}`;

    const res = await fetch(url);
    if (!res.ok) {
        return [];
    }
    const data = await res.json();
    if (data.status !== '1' || !Array.isArray(data.result)) {
        return [];
    }

    return data.result.map(tx => ({
        timeSec: Number(tx.timeStamp),
        valueRaw: tx.value,
        from: tx.from || '0x0',
        to: tx.to || '0x0',
        network: 'Polygon',
        meta: {hash: tx.hash, blockNumber: tx.blockNumber},
    }));
}
